(function(){
    angular
        .module('appback')
        .directive('ngHojaproduccion', hojaProduccion);
        hojaProduccion.$inject = ['HojaService','StockService','$timeout', 'Upload'];
        function hojaProduccion(HojaService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=hojaproduccion.twig',
		        scope: {
                    hc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.seleccionado = false;
                        scope.categoriasFlujos = {};
                        scope.flujos = {};
                        scope.username = "";
                        HojaService.getCategoriasFlujos(function(data){
                            scope.categoriasFlujos = data.categorias_flujos;
                            scope.username = data.username;
                            console.log("categorias flujos", scope.categoriasFlujos);
                            if(angular.isDefined(data)){
                                scope.categoriasFlujos.forEach(cat => {
                                    scope.flujos[cat.slug] = [];
                                });
                                scope.getFlujosHechos(scope.hc.idhojafabricacionactiva);
                            }
                        });

                        scope.getFlujosHechos = function(hoja_id){
                            console.log("flujos", scope.flujos);
                            HojaService.getFlujosHojaFabricacion(hoja_id, function(dataFlujos){
                                console.log("flujos hoja fabricacion",dataFlujos);
                                if(dataFlujos.flujos_hoja.length > 0){
                                    dataFlujos.flujos_hoja.forEach(flujo => {
                                        scope.flujos[flujo.categoria] = flujo.valores;
                                        let categoriaIndex = scope.categoriasFlujos.findIndex(cat => cat.slug === flujo.categoria);
                                        if (categoriaIndex !== -1) {
                                            scope.categoriasFlujos[categoriaIndex].finalizado = flujo.finalizado;
                                        }
                                    });
                                }
                            });
                            console.log("despues de cargar los flujos: categorias", scope.categoriasFlujos);
                            console.log("despues de cargar los flujos: flujos", scope.flujos);
                        }

                        scope.initValoresFlujoMatAlmacen = function(categoriaFlujo, stock){
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.lineahojafabricacion_id == stock.id);
                            if(index!== -1){
                                stock.unidades_preparadas_almacen = scope.flujos[categoriaFlujo][index].unidades_preparadas;
                            }
                        }

                        scope.initValoresFlujoPreparacion = function(categoriaFlujo, stock){
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.lineahojafabricacion_id == stock.id);
                            if(index !== -1){
                                stock.presente_preparacion = scope.flujos[categoriaFlujo][index].presente_preparacion;
                            }
                        }

                        scope.initValoresFlujoImpresion = function(categoriaFlujo, tarea){
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.campo_flujo_id == tarea.id);
                            if(index!== -1){
                                tarea.fecha_validacion = scope.flujos[categoriaFlujo][index].fecha_validacion;
                                tarea.operario_validador = scope.flujos[categoriaFlujo][index].operario_validador;
                                tarea.files = scope.flujos[categoriaFlujo][index].files;
                                tarea.validada = true;
                            }
                        }


                        scope.updateCategoriaMaterialesAlmacen = function(categoriaFlujo, stock){
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.lineahojafabricacion_id == stock.id);
                            if(index!== -1){
                                scope.flujos[categoriaFlujo][index].unidades_preparadas = stock.unidades_preparadas_almacen;
                            }else{
                                scope.flujos[categoriaFlujo].push({lineahojafabricacion_id: stock.id, unidades_preparadas: stock.unidades_preparadas_almacen});
                            }
                        }

                        scope.updateCategoriaPreparacion = function(categoriaFlujo, stock){
                            console.log("update categoria preparacion", categoriaFlujo, stock);
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.lineahojafabricacion_id == stock.id);
                            if(index !== -1){
                                scope.flujos[categoriaFlujo][index].presente_preparacion = stock.presente_preparacion;
                            } else{
                                console.log("nuevo campo añadido", {lineahojafabricacion_id: stock.id, presente_preparacion: stock.presente_preparacion})
                                scope.flujos[categoriaFlujo].push({lineahojafabricacion_id: stock.id, presente_preparacion: stock.presente_preparacion});
                            }
                        }

                        scope.updateCategoriaImpresion = function(categoriaFlujo, tarea){
                            var today = new Date();
                            var timestamp = today.getFullYear() + '-' + 
                                            ('0' + (today.getMonth() + 1)).slice(-2) + '-' + 
                                            ('0' + today.getDate()).slice(-2) + ' ' + 
                                            ('0' + today.getHours()).slice(-2) + ':' + 
                                            ('0' + today.getMinutes()).slice(-2) + ':' + 
                                            ('0' + today.getSeconds()).slice(-2);

                            tarea.fecha_validacion = timestamp;
                            tarea.operario_validador = scope.username;
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.campo_flujo_id == tarea.id);
                            if(index !== -1){
                                scope.flujos[categoriaFlujo][index].fecha_validacion = timestamp;
                                scope.flujos[categoriaFlujo][index].operario_validador = scope.username;
                            }else{
                                scope.flujos[categoriaFlujo].push({
                                    campo_flujo_id: tarea.id, 
                                    fecha_validacion: timestamp, 
                                    operario_validador: scope.username
                                });
                            }
                            tarea.validada = true;
                        }

                        scope.borrarFichero = function(index,categoriaFlujo, tarea){
                            tarea.files.splice(index,1);
                            var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.campo_flujo_id == tarea.id);
                            scope.flujos[categoriaFlujo][index].files = tarea.files;
                        }

                        scope.uploadFiles = function (files, categoriaFlujo, tarea) {
                            if (files && files.length) {
                              for (var i = 0; i < files.length; i++) {
                                console.log("Fichero a subir", files[i]);
                                Upload.upload({
                                      url: '/backend/hojafabricacion/subirficheroflujo',
                                      data: { file: files[i] }
                                  }).then(function (resp) {
                                      if (resp.data.code > 0) {
                                        if (!angular.isDefined(tarea.files)) {
                                            tarea.files = [];
                                        }
                                        tarea.files.push(resp.data);
                                        var index = scope.flujos[categoriaFlujo].findIndex(elemento => elemento.campo_flujo_id == tarea.id);
                                        scope.flujos[categoriaFlujo][index].files = tarea.files;
                                      }
                                      
                                  }, function (resp) {
                                  }, function (evt) {
                                      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                  });
                              }
                              
                            }
                        }

                        scope.guardarFlujo = function(categoriaFlujo){
                            console.log("actualizando flujo", categoriaFlujo);
                            console.log("actualizando flujo", scope.flujos[categoriaFlujo]);
                            HojaService.setFlujoHojaFabricacion(scope.hc.idhojafabricacionactiva, scope.flujos[categoriaFlujo], categoriaFlujo, function(data){
                                console.log("Flujo de la categoría ", categoriaFlujo, " actualizado: ", data);
                            });
                        }

                        scope.finalizarFlujo = function(categoriaFlujo){
                            HojaService.setFlujoHojaFabricacion(scope.hc.idhojafabricacionactiva, scope.flujos[categoriaFlujo], categoriaFlujo, function(data){
                                HojaService.finalizarFlujoHojaFabricacion(scope.hc.idhojafabricacionactiva, categoriaFlujo, function(data){
                                    console.log("flujo finalizado", data);
                                    if(data.acciones){
                                        scope.hc.hojafabricacionactiva.acciones = data.acciones;
                                    }
                                    let categoriaIndex = scope.categoriasFlujos.findIndex(cat => cat.slug === categoriaFlujo);
                                    if (categoriaIndex !== -1) {
                                        scope.categoriasFlujos[categoriaIndex].finalizado = true;
                                    }
                                });
                            });
                        }

                        scope.getExtraLote = function(stock){
                            var stockMat = {"nodetype":"stock_materiales","where":{"material_id": [stock.material_id]}};
                            return stockMat;
                        }

                        scope.updateUnidadesCajas = function(){
                            HojaService.updateUnidadesCajas(scope.hc.idhojafabricacionactiva, scope.hc.hojafabricacionactiva.cajas_completas, scope.hc.hojafabricacionactiva.unidades_sueltas);
                        }
			        });
		        }
          }
      }
})();